function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81C784",
  d: "M12.991 9.233l24.174-.11v16.09L24.787 36.832 12.992 25.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  d: "M12.625 8.75h25v1h-25z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  d: "M12.625 8.75h1v14h-1zm24 0h1v11h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.243 14.83L7.39 19.252m21.693-9.91l-4.34-3.159-4.172 3.165m16.445 5.739l5.628 4.13M7.509 42.9V19.948l17.25 16.498L42.506 19.9v23z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.328 21.079a3.086 3.086 0 01-.868-.599l-.068-.067.053-.08.364-.546a.49.49 0 01.165-.155.437.437 0 01.222-.061c.094 0 .189.031.286.092.08.05.172.11.275.179.1.065.212.13.34.197.09.046.193.084.31.113l.163-1.946c-.2-.06-.397-.128-.593-.205a2.365 2.365 0 01-.63-.364 1.722 1.722 0 01-.459-.583c-.117-.237-.175-.529-.175-.875a2.03 2.03 0 01.604-1.429c.196-.194.436-.353.72-.478a2.65 2.65 0 01.876-.207l.044-.51a.455.455 0 01.126-.279.408.408 0 01.308-.128h.561l-.083.974c.307.06.578.155.81.286.254.143.476.305.665.487l.07.066-.053.08-.29.444a.704.704 0 01-.16.173.384.384 0 01-.23.07.52.52 0 01-.218-.057 6.916 6.916 0 01-.23-.113 5.16 5.16 0 00-.274-.13 1.665 1.665 0 00-.192-.071l-.149 1.776c.203.064.403.134.602.21.235.09.448.205.637.347.193.145.35.326.47.542.122.22.182.493.182.815 0 .314-.052.61-.156.886a2.185 2.185 0 01-.458.736 2.31 2.31 0 01-.738.517c-.265.12-.563.196-.894.23l-.05.615a.46.46 0 01-.126.274.404.404 0 01-.309.131h-.56l.087-1.054a3.684 3.684 0 01-.977-.303zm2.601-1.199c.153-.163.23-.377.23-.65a.637.637 0 00-.053-.272.654.654 0 00-.156-.208 1.065 1.065 0 00-.249-.166 2.559 2.559 0 00-.194-.085l-.138 1.669c.244-.052.43-.149.56-.288zm-1.404-4.469a.887.887 0 00-.272.173.606.606 0 00-.148.218.718.718 0 00-.047.261c0 .107.018.2.052.277.036.08.086.151.15.214.068.065.148.124.242.176.057.031.117.06.18.088l.123-1.49c-.106.021-.2.049-.28.083z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.455 25.426h14.853M18.795 27.45h12.204m-9.393 2.024h6.767",
  stroke: "#371447"
}));

function SvgBillPaymentsMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBillPaymentsMd;